import { useEffect } from 'react';
import { hasWorkBeforeUnload } from '@/stores/workDrafts';
import { sessionPaused } from '@/stores/sessionRecovery';

export function useDraftUnloadWarning() {
  useEffect(() => {
    const warn = (event: BeforeUnloadEvent) => {
      if (!sessionPaused() && !hasWorkBeforeUnload()) return;
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, []);
}
